"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChatOnClientLoad = void 0;
const stream_chat_react_1 = require("stream-chat-react");
const react_1 = __importDefault(require("react"));
const is_defined_1 = require("../../is-defined");
const useChatOnClientLoad = (callback) => {
    const { client } = (0, stream_chat_react_1.useChatContext)();
    const _callback = (event) => {
        if (!event.online)
            return;
        if (!(0, is_defined_1.isDefined)(callback))
            return;
        if ((0, is_defined_1.isUndefined)(client.user))
            return;
        callback(client);
    };
    react_1.default.useEffect(() => {
        client.on('connection.changed', _callback);
        client.on('connection.recovered', _callback);
        return () => {
            client.off('connection.changed', _callback);
            client.off('connection.recovered', _callback);
        };
    }, [client]);
    react_1.default.useEffect(() => {
        if ((0, is_defined_1.isUndefined)(client.user))
            return;
        if ((0, is_defined_1.isUndefined)(callback))
            return;
        callback(client);
    }, [client.user]);
};
exports.useChatOnClientLoad = useChatOnClientLoad;
